import React from "react";

const ClientCrudTableSearchModal = ({listLinesByNumber}) => {

    const handleSubmit = (e) => {
        var inputNumberLine = document.querySelector('#findModal').value;
        //console.log("optionSelected : "+optionSelected);
        e.preventDefault();
        if (inputNumberLine === null || inputNumberLine ===  "") {
            //validateInputOfSearch();
        }else{
            listLinesByNumber(inputNumberLine);
        }       
    }
    return (
        <div>    
            <div className="row mb-2">
                <h6>Busqueda de Líneas:</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black', paddingTop:'15px'}}>
                <>
                    <form className="row g-3">
                        <div className="col-auto">
                            <label htmlFor="staticEmail2">Número de Línea</label>
                        </div>
                        <div className="col-auto">
                            <input type="number" className="form-control" id="findModal" name="findModal" />
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </form>
                </>
            </div>
        </div>
    );
}
export default ClientCrudTableSearchModal;